module.exports = __webpack_public_path__ + "static/media/refresh.007b6376.svg";